import {useTranslation} from 'next-i18next';
import PropTypes from 'prop-types';
import {memo, useMemo} from 'react';

import {ROLES_LIST, ROLES_NAMES} from '@/src/app/constants/roles';
import {SEARCH_FILTERS} from '@/src/app/constants/search';
import TextLocal from '@/src/textLocal/containers/TextLocal';
import {CheckboxCommon, SimpleCollapse, Text} from '@/src/ui';

import FilterRow from './FilterRow';

const getRolesListWithoutClinic = (withoutClinic) => {
  let resultRoles = [];

  if (withoutClinic) {
    resultRoles = ROLES_LIST.filter((item) => {
      return item.value !== ROLES_NAMES.CLINIC;
    });
  } else {
    resultRoles = ROLES_LIST;
  }

  // Temporary disable standard user
  return resultRoles.filter((item) => {
    return item.value !== ROLES_NAMES.CUSTOMER;
  });
};

const UsersTypeFilter = ({query, onChangeHandler, withoutClinic}) => {
  const {t} = useTranslation('common');
  const rolesListWithoutClinic = useMemo(() => {
    return getRolesListWithoutClinic(withoutClinic);
  }, [withoutClinic]);

  return (
    <>
      <SimpleCollapse
        defaultIsOpen
        headTitle={
          <Text
            fontSize={Text.FONT_SIZE.SIZE_16}
            fontWeight={Text.FONT_WEIGHT.MEDIUM}
          >
            <TextLocal id={'search.userTypes'} />
          </Text>
        }
      >
        {rolesListWithoutClinic.map(({value}) => {
          const userType = ROLES_LIST.find((level) => level.value === value);

          return (
            <FilterRow key={userType.value}>
              <CheckboxCommon
                id={userType.value}
                name={userType.value}
                // @ts-ignore
                label={t(userType.label)}
                data-filter-name={SEARCH_FILTERS.FILTERS_TYPE}
                data-value={userType.value}
                checked={
                  !!query[SEARCH_FILTERS.FILTERS_TYPE] &&
                  // @ts-ignore
                  JSON.parse([query[SEARCH_FILTERS.FILTERS_TYPE]]).includes(
                    userType.value
                  )
                }
                onChange={onChangeHandler}
                isSemibold
              />
            </FilterRow>
          );
        })}
      </SimpleCollapse>
    </>
  );
};

UsersTypeFilter.propTypes = {
  query: PropTypes.object.isRequired,
  onChangeHandler: PropTypes.func.isRequired,
  withoutClinic: PropTypes.bool,
};

UsersTypeFilter.propTypes = {
  withoutClinic: false,
};

// @ts-ignore
export default memo(UsersTypeFilter);
